export enum SensorOptionTypeEnum {
  TYPE = 'type',
  LOCALITY = 'locality',
  STATUS = 'status',
}
